import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../assets/css/boxButton.css";
import "../../assets/css/button.css";

const BoxButton = ({
  onNext,
  onPrevious,
  internalStep,
  delegation,
  solicitation,
  getMedia,
  getDelegation,
  privacyAccepted,
}) => {
  const [initialSignedDocument, setInitialSignedDocument] = useState(null);

  useEffect(() => {
    if (delegation?.signedDocument) {
      setInitialSignedDocument({
        name: delegation.signedDocument.split("/").pop(),
        url: `${process.env.REACT_APP_API_ENDPOINT}${delegation.signedDocument}`,
      });
    }
  }, [delegation]);

  const isNextDisabled = internalStep === "STEP2" && !privacyAccepted;

  return (
    <Grid
      container
      className="container-box-button"
      sx={{
        alignItems: "center",
        rowGap: { xs: 2, md: 0 },
      }}
    >
      {/* INDIETRO */}
      <Grid item xs={6} md={4}>
        {internalStep === "STEP8" ||
        internalStep === "STEP0" ||
        internalStep === "STEP7" ||
        (internalStep === "STEP7" &&
          solicitation?.signatureMethods?.length === 1 &&
          solicitation?.signatureMethods[0] === "DIGITAL") ||
        !onPrevious ||
        internalStep === "STEP9" ? null : (
          <Button
            variant="outlined"
            className="button-bg-empty"
            onClick={onPrevious}
            sx={{ display: "block" }}
          >
            <Typography
              className="color-grey"
              sx={{
                textTransform: "initial",
                fontSize: { xs: 16, sm: 18 },
                fontWeight: 500,
              }}
            >
              Indietro
            </Typography>
          </Button>
        )}
      </Grid>

      {/* CENTRO — ICONA + EMAIL */}
      <Grid
        item
        xs={12}
        md={4}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 0.5,
          order: { xs: 3, md: 2 },
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px",
            width: "100%",
          }}
        >
          <Box
            sx={{ marginLeft: { xs: "-20px", md: "0px" } }}
            className="icon-email-support"
          />
          <a
            className="link"
            href="mailto:sollecitazionemps@lexia.it"
            style={{
              color: "#5b5b5b",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                textTransform: "initial",
                fontSize: { xs: 14, md: 16 },
                fontWeight: 500,
                color: "#1b2838",
              }}
            >
              sollecitazionemps@lexia.it
            </Typography>
          </a>
        </div>
      </Grid>

      {/* AVANTI */}
      <Grid
        item
        xs={6}
        md={4}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          order: { xs: 2, md: 3 },
        }}
      >
        {internalStep === "STEP7" || internalStep === "STEP8" ? null : (
          <Button
            onClick={onNext}
            variant="contained"
            className={`button-bg-blue ${
              isNextDisabled ? "button-bg-blue-disabled" : ""
            }`}
            disabled={isNextDisabled}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: 16, sm: 18 },
                fontWeight: 500,
              }}
            >
              Avanti
            </Typography>
          </Button>
        )}

        {internalStep === "STEP8" &&
          delegation.status === "COMPLETED" &&
          initialSignedDocument && (
            <Button
              onClick={() =>
                getMedia(initialSignedDocument.url, "Delega firmata")
              }
              variant="contained"
              sx={{ width: "150px !important" }}
              className="button-bg-blue"
            >
              <Typography
                className="color-light"
                sx={{
                  textTransform: "initial",
                  fontSize: { xs: 16, sm: 18 },
                  fontWeight: 500,
                }}
              >
                Scarica delega
              </Typography>
            </Button>
          )}
      </Grid>
    </Grid>
  );
};

export default BoxButton;
